import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {
	progress: null,
	selectedProcess: null,
	formDataCache: null,
};

const reducerMap = {
	[types.COMPLETE_CURRENT_PROGRESS]: (state) => {
		return {
			...state,
			progress: state.progress ? { ...state.progress, remaining: 0 } : null,
		};
	},
	[types.SET_PROGRESS]: (state, { payload }) => {
		return {
			...state,
			progress: payload.progress,
		};
	},
	[types.SET_PROCESS]: (state, { payload }) => {
		return {
			...state,
			selectedProcess: payload.process || null,
		};
	},
	[types.SET_SIDEBAR_FORM_VALUES_CACHE]: (state, { payload }) => {
		return {
			...state,
			formDataCache: payload.formData,
		};
	},
	[types.RESET]: () => initialState,
};

export default handleActions(reducerMap, initialState);
